module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-12.f2a2731a.png";